/***********************************************************
Royal Hawaiian Services
Alexander Self
2/6/18
Gang View: View user created gangs(teams of employees)
***********************************************************/
import React, { Component } from 'react';
import { Sparklines, SparklinesLine, SparklinesReferenceLine } from 'react-sparklines';
import HarvestInfoCard from '../harvest_info_card';

class HarvestIntroSummary extends Component {
  render() {
    return (
      <div className="row">
        <div className="col s12 m6 l3 xl3">
          <HarvestInfoCard
            header={'Total WIS Lbs'}
            icon={'trending_up'}
            data={this.props.query.summary.totalLbs}
            color={'blue-grey'}
            avg1={<div>Avg WIS lbs/person: <b>{this.props.query.summary.avgTotalLbs}</b></div>}
            child={<Sparklines data={this.props.query.summary.employee.map((e) => e.totalLbs)} height={20}>
              <SparklinesLine style={{ stroke: "white", strokeWidth: "1", fill: "#eceff1", fillOpacity: "0.5" }}  />
              <SparklinesReferenceLine type="mean" />
            </Sparklines>}
           />
        </div>
        <div className="col s12 m6 l3 xl3">
          <HarvestInfoCard
            header={'Total Hours'}
            icon={'hourglass_empty'}
            data={this.props.query.summary.totalHours}
            color={'red'}
            avg1={<div>Avg hours/person: <b>{this.props.query.summary.avgHours}</b></div>}
            child={<Sparklines data={this.props.query.summary.employee.map((e) => e.totalHours)} height={20}>
              <SparklinesLine style={{ stroke: "white", strokeWidth: "1", fill: "#ffebee", fillOpacity: "0.5" }}  />
              <SparklinesReferenceLine type="mean" />
            </Sparklines>}
           />
        </div>
        <div className="col s12 m6 l3 xl3">
          <HarvestInfoCard
            header={'Total Acres'}
            icon={'terrain'}
            data={this.props.query.summary.totalAcresCompleted}
            color={'green'}
            avg1={<div>Avg Acres/Hour: <b>{this.props.query.summary.avgAcresPerHour}</b></div>}
            child={<Sparklines data={this.props.query.summary.employee.map((e) => e.avgAcresPerHour)} height={20}>
              <SparklinesLine style={{ stroke: "white", strokeWidth: "1", fill: "#e8f5e9", fillOpacity: "0.5" }}  />
              <SparklinesReferenceLine type="mean" />
            </Sparklines>}
           />
        </div>
        <div className="col s12 m6 l3 xl3">
          <HarvestInfoCard
            header={'Total Cost'}
            icon={'monetization_on'}
            data={`$${this.props.query.summary.totalCost}`}
            color={'blue'}
            avg1={<div>Avg Cost/lb: <b>${this.props.query.summary.avgCostPerLb}</b></div>}
            child={<Sparklines data={this.props.query.summary.employee.map((e) => e.avgCostPerLb)} height={20}>
              <SparklinesLine style={{ stroke: "white", strokeWidth: "1", fill: "#e1f5fe", fillOpacity: "0.5" }}  />
              <SparklinesReferenceLine type="mean" />
            </Sparklines>}
           />
        </div>
      </div>
    )
  }
}

export default HarvestIntroSummary;




/* END */



// WEBPACK FOOTER //
// ./src/components/harvest/view/report/harvest_intro_summary.jsx